export default __webpack_public_path__ + "static/media/HomeIcon.0c138739.svg";